import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';

const collaborationName = 'RecordLessonProgressCollaboration';

export const RequiredUsageNotSentIdentifier = 'RequiredUsageNotSent';
export class RequiredUsageNotSent extends CollaborationResult {
  constructor() {
    super(collaborationName, RequiredUsageNotSentIdentifier, 'Video usage is required');
  }
}

export const LessonNotFoundIdentifier = 'LessonNotFound';
export class LessonNotFound extends CollaborationResult {
  constructor() {
    super(collaborationName, LessonNotFoundIdentifier, 'Lesson not found to video guid sent');
  }
}

export const LessonProgressNotRecordedBecauseStudentNotFoundIdentifier =
  'LessonProgressNotRecordedBecauseStudentNotFound';
export class LessonProgressNotRecordedBecauseStudentNotFound extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      LessonProgressNotRecordedBecauseStudentNotFoundIdentifier,
      'Lesson progress not recorded because the student was not found',
    );
  }
}

export const ProgressNotRecordedBecauseWasCompleteIdentifier =
  'ProgressNotRecordedBecauseWasComplete';
export class ProgressNotRecordedBecauseWasComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      ProgressNotRecordedBecauseWasCompleteIdentifier,
      'Progress not recorded because was complete',
    );
  }
}

export const ProgressNotRecordedBecauseWasNotCompleteIdentifier =
  'ProgressNotRecordedBecauseWasNotComplete';
export class ProgressNotRecordedBecauseWasNotComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      ProgressNotRecordedBecauseWasNotCompleteIdentifier,
      'Progress not recorded because was not complete',
    );
  }
}

export const LessonProgressRecordedBecauseWasCompleteIdentifier =
  'LessonProgressRecordedBecauseWasComplete';
export class LessonProgressRecordedBecauseWasComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      LessonProgressRecordedBecauseWasCompleteIdentifier,
      'Lesson and video progress recorded because was complete1',
    );
  }
}

export const LessonVideoProgressRecordedBecauseWasCompleteIdentifier =
  'LessonVideoProgressRecordedBecauseWasComplete';
export class LessonVideoProgressRecordedBecauseWasComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      LessonVideoProgressRecordedBecauseWasCompleteIdentifier,
      'Video progress recorded because was complete',
    );
  }
}

export const LessonProgressRecordedAndVideoProgressRecordedBecauseWasCompleteIdentifier =
  'LessonProgressRecordedAndVideoProgressRecordedBecauseWasComplete';
export class LessonProgressRecordedAndVideoProgressRecordedBecauseWasComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      LessonProgressRecordedAndVideoProgressRecordedBecauseWasCompleteIdentifier,
      'Lesson progress recorded and video progress recorded because was complete',
    );
  }
}

export const RecordLessonProgressUnexpectedErrorIdentifier = 'RecordLessonProgressUnexpectedError';
export class RecordLessonProgressUnexpectedError extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      RecordLessonProgressUnexpectedErrorIdentifier,
      'Unexpected error occurred on the service',
    );
  }
}

export const UnexpectedExceptionIdentifier = 'UnexpectedException';
export class UnexpectedException extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      UnexpectedExceptionIdentifier,
      'Unexpected error occurred on the service',
    );
  }
}
